/**
 * The four AI strategy cards (prototype `vCompare`'s `stratbar`).
 *
 * Each card previews what it *would* cost without applying it, so the purchaser can compare
 * approaches before committing — "cheapest" and "fewest suppliers" often differ by less than
 * the admin of running four POs is worth.
 *
 * Picking one replaces the whole allocation with that strategy's suggestion; the user then
 * adjusts individual cells by hand.
 */

import { Money } from '../../components/Money'
import { STRATEGIES, STRATEGY_LABELS, type Strategy, type StrategyPreview } from '../../lib/compare'
import type { DisplayCurrency } from '../../lib/displayCurrency'
import type { Currency } from '../../lib/types'

export function StrategyBar({
  active,
  previews,
  baseCurrency,
  display,
  onPick,
}: {
  active: Strategy
  previews: Record<Strategy, StrategyPreview>
  baseCurrency: Currency
  /** The currency the customer is quoted in, with the rates to show base figures in it. */
  display?: DisplayCurrency
  onPick: (strategy: Strategy) => void
}) {
  return (
    <div className="stratbar">
      {STRATEGIES.map((strategy) => {
        const preview = previews[strategy]
        const { title, hint } = STRATEGY_LABELS[strategy]
        return (
          <button
            key={strategy}
            type="button"
            className={`strat${strategy === active ? ' active' : ''}`}
            aria-pressed={strategy === active}
            onClick={() => onPick(strategy)}
          >
            {title}
            <small>{hint}</small>
            <span className="stratprev">
              <Money value={{ amount: preview.total, currency: baseCurrency }} in={display?.currency} fx={display?.fx} /> ·{' '}
              {preview.supplierCount} supplier{preview.supplierCount === 1 ? '' : 's'}
            </span>
          </button>
        )
      })}
    </div>
  )
}
